import TermCreateEdit from "../AdminTermCreateEdit";

export default class AdminTermCreateEditBrightreeStopHoldReason extends TermCreateEdit {
    /**
     * @returns {string} The term type.
     */
    getType() {
        return "brightree_stop_hold_reason";
    }
}
